import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import plusIcon from "@iconify/icons-mdi/plus";
import { InlineIcon } from "@iconify/react";
import {
  MyTimesheetMyTimesheetTable,
  MyTimesheetTimesheetsCalendar,
} from "my-timesheet/components";
import { OcCard } from "oc/components";
import useOcButtonGroup from "oc/hooks/use-button-group";

interface MyTimesheetMyTimesheetProps {
  onNewRequest: (date: Date) => void;
  data: any; // Replace 'any' with the appropriate type
  loading: boolean;
  error: any; // Replace 'any' with the appropriate type
  events: any; // Replace 'any' with the appropriate type
  onShowRequest: (id: string) => void; // Adjust type as needed
  currentDate: Date;
  onChangeCurrentDate: (date: Date) => void;
  period: any; // Replace 'any' with the appropriate type
  onChangePeriod: (period: any) => void; // Adjust type as needed
  openedItem: any; // Replace 'any' with the appropriate type
  isMobile: boolean;
}

export const MyTimesheetMyTimesheet: React.FC<MyTimesheetMyTimesheetProps> = ({
  onNewRequest,
  data,
  loading,
  error,
  events,
  onShowRequest,
  currentDate,
  onChangeCurrentDate,
  period,
  onChangePeriod,
  openedItem,
  isMobile,
}) => {
  const { t } = useTranslation();

  const buttonsDef = isMobile ? ["OC_TABLE"] : ["OC_CALENDAR", "OC_TABLE"];
  const { OcButtonGroup, selectedButton, handleButtonChange } =
    useOcButtonGroup({
      id: "MySheetMyTimesheet",
      buttonsDef,
    });

  useEffect(() => {
    if (isMobile) {
      handleButtonChange(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const handleNewRequest = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onNewRequest(new Date());
  };

  return (
    <OcCard
      label={t("MY_TIMESHEET_ACTIVITIES")}
      loading={loading}
      error={error}
    >
      <>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          padding="32px 0px"
        >
          <Box width="200px" />
          {!isMobile && (
            <Box display="flex" flexDirection="column" alignItems="center">
              <OcButtonGroup />
            </Box>
          )}
          <Box width="200px" textAlign="right">
            <Button
              id="new-activity"
              variant="contained"
              color="primary"
              disableElevation
              startIcon={<InlineIcon icon={plusIcon} />}
              onClick={handleNewRequest}
              disabled={loading || openedItem ? true : false}
            >
              {t("MY_TIMESHEET_NEW_ACTIVITY")}
            </Button>
          </Box>
        </Box>
        {selectedButton === "OC_CALENDAR" ? (
          <MyTimesheetTimesheetsCalendar
            data={events}
            currentDate={currentDate}
            onChangeCurrentDate={onChangeCurrentDate}
            onShowRequest={onShowRequest}
            onDataFormatChange={(format: string) => {
              const index = buttonsDef.indexOf(format);
              if (index !== -1) handleButtonChange(index);
            }}
            onNewRequest={onNewRequest}
          />
        ) : (
          <>
            <MyTimesheetMyTimesheetTable
              showDateSelector={true}
              data={data}
              currentDate={currentDate}
              onChangeCurrentDate={onChangeCurrentDate}
              onShowRequest={onShowRequest}
              period={period}
              onChangePeriod={onChangePeriod}
              showOnlyRequests={false} // Adjust as needed
              loading={loading}
              error={error}
            />
          </>
        )}
      </>
    </OcCard>
  );
};

export default MyTimesheetMyTimesheet;
